import React from "react"
import Link from "gatsby-link"

import CallToAction from "./call-to-action"
import TopNav from "./topnav"
import { NavigationDataItem } from "../utils/extract-navigation"
import Menu from "./menu"
import VideoSurface from "./util/video-surface"

import { PageFieldsFragment } from "../../graphql-types"

export interface MainHeroProps {
  navigationData: NavigationDataItem[]
  navigationSecondaryData: NavigationDataItem[]
  title: string
  headerImage: string
  headerVideo?: PageFieldsFragment["headerVideo"]["video"]
  titleImage: string
  preamble: string
  ctas: PageFieldsFragment["ctas"]
  variant?: string
}

const MainHero: React.FC<MainHeroProps> = props => {
  return (
    <section
      className={`c-main-hero ${props.variant ? `${props.variant}` : ""} `}
      style={{
        backgroundImage: `url(${props.headerImage})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      {props.headerVideo && (
        <VideoSurface
          className="c-main-hero__video"
          video={props.headerVideo}
        />
      )}

      <div className="header o-wrapper u-flex">
        <Link to="/" className="c-logo o-row">
          <span className="is-visually-hidden">Northvolt</span>
        </Link>

        <TopNav items={props.navigationData} />
        <Menu
          navigationData={props.navigationData}
          navigationSecondaryData={props.navigationSecondaryData}
        ></Menu>
      </div>
      <div className="c-main-hero__text-container o-wrapper">
        <div className="o-row o-6-of-12@large u-left@large">
          <div
            className="c-main-hero__header-text"
            style={{
              backgroundImage: `url(${props.titleImage})`,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
            }}
          >
            <h1 className="u-visually-hidden">{props.title}</h1>
          </div>

          <div
            className="c-main-hero__preamble"
            dangerouslySetInnerHTML={{ __html: props.preamble }}
          />
          <div className="u-flex u-flex-wrap">
            {props.ctas &&
              props.ctas.map(cta => (
                <CallToAction
                  key={cta.id}
                  color={cta.hasColor ? "green" : null}
                  isTransparent={cta.isTransparent}
                  openInNewTab={cta.openInNewTab}
                  url={cta.url}
                >
                  {cta.text}
                </CallToAction>
              ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default MainHero
